module.exports = __webpack_public_path__ + "static/media/om_beard_scruff_round__oval_vector.50f97595.svg";